
import { IonButton, IonButtons, IonCard, IonCardContent, IonCol, IonContent, IonFooter, IonGrid, IonHeader, IonIcon, IonImg, IonInput, IonLabel, IonLoading, IonModal, IonRow, IonTextarea, IonTitle, IonToast, IonToolbar } from '@ionic/react';
import { arrowBack, arrowBackOutline, copy } from 'ionicons/icons';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router';

import CryptoJS from 'crypto-js';
import { armazenarProjeto, empresaCarregar, incluirProjeto, pagamentoPedido, requestService } from '../../../../../Utils/Services';
import { MessageContext } from '../../../../../contexts/MessageContext';
import ConfirmarCelular from '../../../../Inicio/ConfirmarCelular/ConfirmarCelular';
import RevisarPedido from '../../../../Inicio/RevisarPedido/RevisarPedido';
import "./OrdensFechar.css";
import iconPix from "./imgs/pix.svg";

type Props = {
  produtos: any[];
  logado: any;
  closeAction: Function;
  closeActionSimple: Function;
};

const OrdensFechar: React.FC<Props> = (props: Props) => {

  const history = useHistory<any>();
  const [showLoading, setShowLoading] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState("");
  const buscarInputRef = useRef<any>(null);
  const [taxaEntrega, setTaxaEntrega] = useState<any>();
  const [showRevisarPedido, setShowRevisarPedido] = useState(false);

  const { dadosEmpresa, setDadosEmpresa, verificarPagamentoPedido, pararVerificacaoPagamento } = useContext(MessageContext);

  const [showModalQrCode, setShowModalQrCode] = useState(false);
  const [qrCodeData, setQRCodeData] = useState<any>();
  const [qrCode, setQRCode] = useState<any>();
  const { idPagamento, setIdPagamento } = useContext(MessageContext);
  const { isPaymentCompleted, setIsPaymentCompleted } = useContext(MessageContext);
  const [valorPagamento, setValorPagamento] = useState<any>();

  const [timeLeft, setTimeLeft] = useState(6 * 60); // 10 minutos em segundos
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;

  const [arrayFormaPagamento, setArrayFormaPagamento] = useState<any[]>([]); // Array para armazenar campos dinâmicos


  const [desconto, setDesconto] = useState('');
  const [taxaServico, setTaxaServico] = useState('');

  const [valorTotalProdutos, setValorTotalProdutos] = useState<any>();
  const [valorTotal, setValorTotal] = useState<any>();

  const { listaItemProdutos, setListaItemProdutos } = useContext(MessageContext);

  const [showModalConfirmarCelular, setShowModalConfirmarCelular] = useState(false);



  useEffect(() => {

    carregarProjeto();

  }, []);

  useEffect(() => {

    try {
      let taxaServicoFloat = parseFloat(taxaServico?.replace(/\./g, '').replace(/\,/g, '.'));
      let descontoFloat = parseFloat(desconto?.replace(/\./g, '').replace(/\,/g, '.'));
      let taxaEntregaFloat = parseFloat(taxaEntrega?.replace(/\./g, '').replace(/\,/g, '.'));

      let valorTotalRecalculado = 0;
      if (valorTotalProdutos) {
        valorTotalRecalculado = parseFloat(valorTotalProdutos.replace(/\./g, '').replace(/\,/g, '.'));
      }

      if (taxaEntrega) {
        valorTotalRecalculado += (taxaEntregaFloat ? taxaEntregaFloat : 0);
      }

      if (desconto) {
        valorTotalRecalculado += - (descontoFloat ? descontoFloat : 0);
      }
      if (taxaServico) {
        valorTotalRecalculado += (valorTotalRecalculado * (taxaServicoFloat / 100));
      }

      setValorTotal(valorTotalRecalculado.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }));

    } catch (error) {
      console.log("erro ao calcular", error);
    }
  }, [taxaEntrega, taxaServico, desconto, valorTotalProdutos]);

  function carregarProjeto() {

    const consultar = async () => {

      setDesconto(localStorage.getItem("desconto") || "");
      setTaxaEntrega(localStorage.getItem("taxaEntrega") || "");

      // Calcula a nova soma dos valores após a remoção
      const totalValor = props.produtos.reduce((total: any, item: any) => {
        const itemValorNumerico = parseFloat(
          item.subtotal.toString().replace(/\./g, '').replace(/\,/g, '.')
        );
        return total + itemValorNumerico;
      }, 0);

      if (totalValor) {
        setValorTotalProdutos(totalValor?.toLocaleString('pt-br', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }));
      }
      else {
        setValorTotalProdutos("0,00");
      }

      if (totalValor) {
        setValorTotal(totalValor?.toLocaleString('pt-br', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }));
      }
      else {
        setValorTotal("0,00");
      }

      // Exemplo: você pode armazenar a nova soma em outro estado ou usar conforme necessário
      console.log("Nova soma dos valores:", totalValor);

      if (buscarInputRef.current) {
        buscarInputRef.current.setFocus();
      }
    }

    consultar();
  }

  const onChangeValorArray = (e: any, index: number) => {
    // e.persist();
    e.preventDefault();

    let v = e.target.value;

    v = v.replace(/\d{9}/, '');
    v = v.replace(/\D/g, '');
    v = v.replace(/(\d{1})(\d{1,2})$/, "$1,$2");
    v = v.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
    v = v.replace(/^(\d)/g, "$1");

    const novosCampos: any = [...arrayFormaPagamento];
    novosCampos[index].valor = v;
    setArrayFormaPagamento(novosCampos);

  };

  useEffect(() => {

    if (isPaymentCompleted) {
      // Se o modal estiver aberto, fecha ele
      if (showModalQrCode) {
        setShowModalQrCode(false);
      }

      setIsPaymentCompleted(false);

      setListaItemProdutos([]);
      window.localStorage.removeItem("desconto");

      let empresaid = localStorage.getItem("empresaid") || "";

      // ✅ Prioriza o contexto sobre o localStorage
      if (dadosEmpresa?.pk) {
        empresaid = dadosEmpresa.pk;
        console.log("🔄 isPaymentCompleted - Usando empresaid do contexto:", empresaid);
      }

      carregarEmpresa(empresaid);

      props.closeAction();
    }

  }, [isPaymentCompleted]);

  useEffect(() => {
    let timer: NodeJS.Timeout;

    if (showModalQrCode) {
      // Reseta o contador para 10 minutos sempre que o modal é aberto
      setTimeLeft(6 * 60); // 10 minutos em segundos (10 * 60)

      // Inicia o intervalo de 1 segundo para o countdown
      timer = setInterval(() => {
        setTimeLeft(prevTime => {
          if (prevTime > 0) {
            return prevTime - 1;
          } else {
            clearInterval(timer); // Limpa o intervalo quando o tempo chega a 0
            // Quando o tempo acaba, redireciona o usuário
            handleQrCodeExpired();
            return 0;
          }
        });
      }, 1000);
    }

    // Limpa o timer quando o modal fecha ou o componente é desmontado
    return () => clearInterval(timer);

  }, [showModalQrCode]);

  // Função que será chamada quando o QR Code expira
  const handleQrCodeExpired = () => {
    setTextToast("Código expirado. Gere um novo para efetuar o pagamento.");
    setShowToast(true);

    setShowModalQrCode(false);
    pararVerificacaoPagamento(); // Para a verificação quando o QR Code expira
  };


  async function carregarEmpresa(loja: any) {

    const consultar = async () => {

      requestService(empresaCarregar.url.replace("{id}", loja.replace(/#/g, '%23')), {
        method: empresaCarregar.method
      },
        history,
        (response: any) => {
          console.log("carregou empresa pedido", response.Item);
          setDadosEmpresa(response.Item);
        },
        (error: any) => {
          console.log(error);
        });

    }

    await consultar();
  }

  // Função para gerar pagamento do Mercado Pago
  const gerarPagamentoMercadoPago = async () => {

    setShowLoading(true);

    try {
      let empresaid = localStorage.getItem("empresaid") || "";

      // ✅ Prioriza o contexto sobre o localStorage
      if (dadosEmpresa?.pk) {
        empresaid = dadosEmpresa.pk;
        console.log("🔄 gerarPagamentoMercadoPago - Usando empresaid do contexto:", empresaid);
      }

      const nomeLocal = (localStorage.getItem("nome") || "").trim();
      var token: string = "";
      var tkn = localStorage.getItem("token");
      if (typeof (tkn) === "string") { token = tkn; }

      // Monta o body com nome e valor
      const body = {
        nome: nomeLocal || "",
        valor: parseFloat(valorTotal?.replace(/\./g, '').replace(/\,/g, '.') || "1000,00")
      };

      console.log("📦 Body da requisição:", body);

      let resp = await fetch(pagamentoPedido.url.replace("{id}", empresaid.replaceAll(/#/g, "%23")),
        {
          method: pagamentoPedido.method,
          headers: [
            ["token", token],
            ["Content-Type", "application/json"]
          ],
          credentials: 'include',
          body: JSON.stringify(body)
        });
      let retorno = await resp.json();

      if (resp.status === 400 || resp.status === 401) {
        setTextToast("Ocorreu um erro ao gerar o Pagamento, entre em contato com o suporte.");
        setShowToast(true);
      }
      else {
        if (retorno) {
          setIdPagamento(retorno.id);
          setQRCode(retorno.point_of_interaction.transaction_data.qr_code);
          setQRCodeData(retorno.point_of_interaction.transaction_data.qr_code_base64);
          setValorPagamento(retorno.transaction_amount);


          armazenarPedido(retorno.id)


        }
        else {
          setTextToast("Ocorreu um erro ao gerar o Pagamento, entre em contato com o suporte.");
          setShowToast(true);
        }
      }

    } catch (error) {
      setTextToast("Ocorreu um erro ao gerar o Pagamento, verifique as informações e tente novamente.");
      setShowToast(true);
    } finally {
      setShowLoading(false);
    }
  };

  // Função para definir a forma de pagamento (substitui ao invés de adicionar)
  const handleAdicionarFormaPagamento = (opcao: string, tipo: string) => {
    const valorTotalNumerico = parseFloat(valorTotal?.replace(/\./g, '').replace(/\,/g, '.'));

    console.log("valorTotalNumerico", valorTotalNumerico);

    let uuid = crypto.randomUUID();
    console.log("uuid", uuid);

    // Cria a nova forma de pagamento
    const novoPagamento = {
      id: uuid,
      pagamento: opcao,
      tipo: tipo,
      valor: valorTotalNumerico.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
    };

    // Substitui a forma de pagamento atual
    setArrayFormaPagamento([novoPagamento]);
  };

  const handleRemoverFormaPagamento = (index: number) => {
    // Removendo o item pelo índice
    const formaPagamentoAtualizada = arrayFormaPagamento.filter(
      (_: any, i: any) => i !== index
    );

    // Atualizando o estado
    setArrayFormaPagamento(formaPagamentoAtualizada);
    // alterarFormaPagamento(formaPagamentoAtualizada);
  };

  function calcularValorRestante(valorTotal: string, arrayFormaPagamento: any[]): any {

    const totalPagamentos = arrayFormaPagamento.reduce((total: number, campo: any) => {
      return total + parseFloat(campo.valor?.replace(/\./g, '').replace(/\,/g, '.')) || 0;
    }, 0);

    const valorTotalFloat = parseFloat(valorTotal?.replace(/\./g, '').replace(/\,/g, '.')) || 0;

    // Calcula o valor restante e garante que não seja negativo
    const valorRestante = Math.max(0, valorTotalFloat - totalPagamentos);

    // Retorna o valor formatado
    return valorRestante;
  }

  function calcularValorTroco(valorTotal: string, arrayFormaPagamento: any[]): string {
    const totalPagamentos = arrayFormaPagamento.reduce((total: number, campo: any) => {
      return total + parseFloat(campo.valor?.replace(/\./g, '').replace(/\,/g, '.')) || 0;
    }, 0);

    const valorTotalFloat = parseFloat(valorTotal?.replace(/\./g, '').replace(/\,/g, '.')) || 0;

    // Calcula o valor restante, garantindo que não seja negativo
    const valorTroco = Math.max(0, totalPagamentos - valorTotalFloat);

    // Formata o valor restante para o padrão brasileiro (duas casas decimais, vírgula e ponto)
    return valorTroco.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  async function confirmarPedido() {
    const nomeLocal = (localStorage.getItem("nome") || "").trim();
    const telefoneLocal = (localStorage.getItem("telefone") || "").trim();
    const telefoneDigits = telefoneLocal.replace(/\D/g, "");
    console.log("telefoneDigits", telefoneDigits);
    const telefoneValido = telefoneDigits.startsWith("55") && (telefoneDigits.length === 13);

    if (!nomeLocal || !telefoneValido) {
      setTextToast("Informe nome e celular válidos.");
      setShowToast(true);
      setShowModalConfirmarCelular(true);
      return;
    }

    setShowRevisarPedido(true);
  }

  // Função para formatar a data no padrão brasileiro
  function formatarData(isoDate: string): string {
    if (!isoDate) return "";
    const date = new Date(isoDate);
    const dia = String(date.getDate()).padStart(2, '0');
    const mes = String(date.getMonth() + 1).padStart(2, '0');
    const ano = date.getFullYear();
    return `${dia}/${mes}/${ano}`;
  }

  // Função para formatar a hora
  function formatarHora(isoTime: string): string {
    if (!isoTime) return "";
    // Extrair a parte da hora do formato ISO (2025-12-01T18:10)
    const timePart = isoTime.includes('T') ? isoTime.split('T')[1] : isoTime;
    const [hora, minuto] = timePart.split(':');
    return `${hora}:${minuto}`;
  }

  async function fazerPedido() {

    let empresaid = localStorage.getItem("empresaid") || "";
    let empresanome = localStorage.getItem("empresanome") || "";

    // ✅ Prioriza o contexto sobre o localStorage
    if (dadosEmpresa?.pk) {
      empresaid = dadosEmpresa.pk;
      console.log("🔄 fazerPedido - Usando empresaid do contexto:", empresaid);
    }

    // ✅ Prioriza o contexto sobre o localStorage
    if (dadosEmpresa?.empresaNome) {
      empresanome = dadosEmpresa.empresaNome;
      console.log("🔄 fazerPedido - Usando empresanome do contexto:", empresanome);
    }

    const complemento = localStorage.getItem("complementoEntrega") || "";

    // Debug logging para investigar localStorage
    console.log("🔍 fazerPedido - Debug localStorage:");
    console.log("📋 empresaid (final):", empresaid);
    console.log("📋 empresanome (final):", empresanome);
    console.log("🏢 localStorage completo:", {
      empresaid: localStorage.getItem("empresaid"),
      empresanome: localStorage.getItem("empresanome")
    });

    if (dadosEmpresa) {
      console.log("📊 dadosEmpresa.empresaId:", dadosEmpresa.pk);
      console.log("📊 dadosEmpresa.empresaNome:", dadosEmpresa.empresaNome);
    }

    const nome = (localStorage.getItem("nome") || "").trim();
    const telefone = (localStorage.getItem("telefone") || "").trim();
    const endereco = localStorage.getItem("enderecoEntrega") || "";
    const enderecoLat = localStorage.getItem("latitudeEntrega") || "";
    const enderecoLng = localStorage.getItem("longitudeEntrega") || "";

    const tipoAgendamento = localStorage.getItem("tipoAgendamento") || "";
    const dataAgendamento = localStorage.getItem("dataAgendamento") || "";
    const horaAgendamento = localStorage.getItem("horaAgendamento") || "";

    const formaPagamento = arrayFormaPagamento[0].pagamento;
    const troco = calcularValorTroco(valorTotal, arrayFormaPagamento);

    const pkCliente = "";

    const SECRET_KEY = "fcc196694c444938b340251bf7771a2b";
    const newToken = CryptoJS.HmacSHA256(SECRET_KEY, SECRET_KEY).toString();

    let objRequest = {
      "nomeCliente": nome,
      "telefoneCliente": telefone,
      lojas: [{ "empresaLojaId": empresaid, "empresaLojaNome": empresanome }],
      "pularEndereco": false,
      "endereco": endereco || "",
      "complemento": complemento || "",
      "enderecoLat": enderecoLat,
      "enderecoLng": enderecoLng,
      "clienteid": pkCliente.replaceAll(/#/g, '%23'),
      "responsavelid": "",
      "empresaid": empresaid || "",
      "responsaveis": [dadosEmpresa.usuarioPush], //[pkUsuario.replaceAll(/#/g, '%23')],
      "interno": false,
      "produtos": listaItemProdutos,
      "formaPagamento": formaPagamento,
      "troco": troco,
      "taxaEntrega": taxaEntrega,
      "desconto": desconto,
      "taxaServico": taxaServico,
      "internet": true,
      "agendamento": tipoAgendamento == "AGENDADO"
        ? "AGENDADO | " + formatarData(dataAgendamento) + " às " + formatarHora(horaAgendamento)
        : ""
    };

    if (endereco == "RETIRADA" || dadosEmpresa.tipoConfiguracoesEntrega != "raio") {
      objRequest.pularEndereco = true;
    }

    setShowLoading(true);

    requestService(incluirProjeto.url, {
      method: incluirProjeto.method,
      headers: [
        ["token", newToken]
      ],
      body: JSON.stringify(objRequest),
      credentials: 'include'
    },
      history,
      (response: any) => {

        console.log("response", response);

        if (response.message && response.message.pk) {
          // atualiza estoque
          if (response.message.data) {
            setDadosEmpresa(response.message.data)
          }

          setListaItemProdutos([]);
          window.localStorage.removeItem("desconto");

          props.closeAction();


        }

      },
      (error: any) => {
        console.log("error", error);
        setTextToast(error.message);
        setShowToast(true);

      }).finally(() => {
        setShowLoading(false);
      });

  }

  async function armazenarPedido(idPagamento: any) {

    let empresaid = localStorage.getItem("empresaid") || "";
    let empresanome = localStorage.getItem("empresanome") || "";

    // ✅ Prioriza o contexto sobre o localStorage
    if (dadosEmpresa?.pk) {
      empresaid = dadosEmpresa.pk;
      console.log("🔄 armazenarPedido - Usando empresaid do contexto:", empresaid);
    }

    // ✅ Prioriza o contexto sobre o localStorage
    if (dadosEmpresa?.empresaNome) {
      empresanome = dadosEmpresa.empresaNome;
      console.log("🔄 armazenarPedido - Usando empresanome do contexto:", empresanome);
    }

    const complemento = localStorage.getItem("complementoEntrega") || "";

    // Debug logging para investigar localStorage
    console.log("🔍 fazerPedido - Debug localStorage:");
    console.log("📋 empresaid (final):", empresaid);
    console.log("📋 empresanome (final):", empresanome);
    console.log("🏢 localStorage completo:", {
      empresaid: localStorage.getItem("empresaid"),
      empresanome: localStorage.getItem("empresanome")
    });

    if (dadosEmpresa) {
      console.log("📊 dadosEmpresa.empresaId:", dadosEmpresa.pk);
      console.log("📊 dadosEmpresa.empresaNome:", dadosEmpresa.empresaNome);
    }

    const nome = (localStorage.getItem("nome") || "").trim();
    const telefone = (localStorage.getItem("telefone") || "").trim();
    const endereco = localStorage.getItem("enderecoEntrega") || "";
    const enderecoLat = localStorage.getItem("latitudeEntrega") || "";
    const enderecoLng = localStorage.getItem("longitudeEntrega") || "";

    const tipoAgendamento = localStorage.getItem("tipoAgendamento") || "";
    const dataAgendamento = localStorage.getItem("dataAgendamento") || "";
    const horaAgendamento = localStorage.getItem("horaAgendamento") || "";

    const formaPagamento = arrayFormaPagamento[0].pagamento;
    const troco = calcularValorTroco(valorTotal, arrayFormaPagamento);

    const pkCliente = "";

    const SECRET_KEY = "fcc196694c444938b340251bf7771a2b";
    const newToken = CryptoJS.HmacSHA256(SECRET_KEY, SECRET_KEY).toString();

    console.log("*******idPagamento", idPagamento);
    let objRequest = {
      "idPagamento": idPagamento,
      "nomeCliente": nome,
      "telefoneCliente": telefone,
      lojas: [{ "empresaLojaId": empresaid, "empresaLojaNome": empresanome }],
      "pularEndereco": false,
      "endereco": endereco || "",
      "complemento": complemento || "",
      "enderecoLat": enderecoLat,
      "enderecoLng": enderecoLng,
      "clienteid": pkCliente.replaceAll(/#/g, '%23'),
      "responsavelid": "",
      "empresaid": empresaid || "",
      "responsaveis": [dadosEmpresa.usuarioPush], //[pkUsuario.replaceAll(/#/g, '%23')],
      "interno": false,
      "produtos": listaItemProdutos,
      "formaPagamento": formaPagamento,
      "troco": troco,
      "taxaEntrega": taxaEntrega,
      "desconto": desconto,
      "taxaServico": taxaServico,
      "internet": true,
      "agendamento": tipoAgendamento == "AGENDADO"
        ? "AGENDADO | " + formatarData(dataAgendamento) + " às " + formatarHora(horaAgendamento)
        : ""
    };

    if (endereco == "RETIRADA" || dadosEmpresa.tipoConfiguracoesEntrega != "raio") {
      objRequest.pularEndereco = true;
    }

    setShowLoading(true);

    requestService(armazenarProjeto.url, {
      method: armazenarProjeto.method,
      headers: [
        ["token", newToken]
      ],
      body: JSON.stringify(objRequest),
      credentials: 'include'
    },
      history,
      (response: any) => {

        console.log("response", response);

        if (response && response.pk) {
          setShowModalQrCode(true);
          // Inicia verificação do pagamento
          verificarPagamentoPedido(idPagamento);
        }
        else {
          setTextToast("Ocorreu um erro ao armazenar o pedido, entre em contato com o suporte.");
          setShowToast(true);
        }

      },
      (error: any) => {
        console.log("error", error);
        setTextToast(error.message);
        setShowToast(true);

      }).finally(() => {
        setShowLoading(false);
      });

  }

  async function closeModalConfirmarCelularSimple() {
    setShowModalConfirmarCelular(false);
  }

  async function closeModalConfirmarCelular(nome: any, celular: any) {
    setShowModalConfirmarCelular(false);
    localStorage.setItem("nome", nome);
    localStorage.setItem("telefone", celular);
    confirmarPedido();
  }

  const formatarHorario = (horario: string) => {
    return horario.split(":").slice(0, 2).join(":");
  };

  return (

    <>
      <IonHeader className="ion-no-border">
        <IonToolbar>

          <IonButtons slot="start">
            <IonButton onClick={() => props.closeActionSimple(arrayFormaPagamento)}>
              <IonIcon icon={arrowBackOutline} />
            </IonButton>
          </IonButtons>

          <IonTitle>Fechamento</IonTitle>

        </IonToolbar>


      </IonHeader>

      <IonContent fullscreen={false}>

        <IonGrid>

          {/* <IonRow style={{ "borderBottom": "1px solid #e0e0e0" }}>
            <IonCol size="6" style={{ display: 'flex', alignItems: 'center' }}>
              <IonLabel>Desconto:</IonLabel>
            </IonCol>
            <IonCol size="6" style={{ textAlign: 'right' }}>
              <IonSelect
                placeholder="Selecione"
                value={desconto}
                onIonChange={(e) => {
                  setDesconto(e.detail.value); // Atualiza o valor do desconto
                }}
              >
                {opcoesDesconto.map((opcao, index) => (
                  <IonSelectOption key={index} value={opcao.value}>
                    {opcao.label}
                  </IonSelectOption>
                ))}
              </IonSelect>
            </IonCol>

          </IonRow> */}

          <IonRow>
            <IonCol size="12" style={{}}>
              <IonLabel>Escolha a forma de pagamento:</IonLabel>
            </IonCol>
          </IonRow>

          {/* Seção: Pagar agora - Pix Automatizado */}
          {dadosEmpresa.formaPagamento?.some((item: any) =>
            item.exibirDelivery && item.tipo === "Pix Automatizado"
          ) && (
              <>
                <IonRow style={{ marginTop: '10px' }}>
                  <IonCol size="12">
                    <div style={{
                      backgroundColor: '#f5f5f5',
                      padding: '16px',
                      borderRadius: '12px',
                      border: '1px solid #e9ecef'
                    }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
                        <h3 style={{
                          margin: '0',
                          color: 'var(--ion-color-primary)',
                          fontSize: '18px',
                          fontWeight: 'bold'
                        }}>
                          Pagar agora
                        </h3>
                        <span style={{
                          backgroundColor: 'var(--ion-color-success)',
                          color: 'white',
                          padding: '4px 12px',
                          borderRadius: '20px',
                          fontSize: '12px',
                          fontWeight: 'bold'
                        }}>
                          Mais rápido
                        </span>
                      </div>
                      <p style={{
                        fontSize: '14px',
                        color: '#6c757d',
                        margin: '0 0 16px 0'
                      }}>
                        Pague com agilidade e segurança
                      </p>

                      {dadosEmpresa.formaPagamento?.map((item: any, index: any) => {
                        if (!item.exibirDelivery || item.tipo !== "Pix Automatizado") return null;

                        const isSelected = arrayFormaPagamento.length > 0 &&
                          arrayFormaPagamento[0].pagamento === item.nome &&
                          arrayFormaPagamento[0].tipo === item.tipo;

                        return (
                          <div
                            key={index}
                            onClick={() => handleAdicionarFormaPagamento(item.nome, item.tipo)}
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              padding: '12px',
                              backgroundColor: 'white',
                              borderRadius: '8px',
                              border: isSelected ? "2px solid #FF0000" : "1px solid #e0e0e0",
                              cursor: 'pointer',
                              // transition: 'all 0.3s ease'
                            }}
                          >
                            <div style={{
                              width: '50px',
                              height: '50px',
                              borderRadius: '8px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              marginRight: '12px'
                            }}>
                              <IonImg
                                src={iconPix}
                                alt="Pix"
                                style={{ width: "30px", height: "30px" }}
                              />
                            </div>
                            <div style={{ flex: 1 }}>
                              <div style={{
                                fontWeight: 'bold',
                                fontSize: '16px',
                                color: '#333'
                              }}>
                                {item.nome}
                              </div>
                              <div style={{
                                fontSize: '12px',
                                color: '#6c757d',
                                marginTop: '2px'
                              }}>
                                Pagamento com Pix online
                              </div>
                              <div style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                backgroundColor: 'var(--ion-color-success)',
                                color: 'white',
                                padding: '2px 8px',
                                borderRadius: '12px',
                                fontSize: '11px',
                                marginTop: '4px'
                              }}>
                                ⚡ Entrega mais rápida
                              </div>
                            </div>
                            {/* <div style={{
                              width: '20px',
                              height: '20px',
                              borderRadius: '50%',
                              border: isSelected ? '6px solid var(--ion-color-primary)' : '2px solid #dee2e6',
                              backgroundColor: isSelected ? 'var(--ion-color-primary)' : 'transparent'
                            }} /> */}
                          </div>
                        );
                      })}
                    </div>
                  </IonCol>
                </IonRow>
              </>
            )}

          {/* Seção: Pagar na entrega - Outros tipos */}
          {dadosEmpresa.formaPagamento?.some((item: any) =>
            item.exibirDelivery && item.tipo !== "Pix Automatizado"
          ) && (
              <>
                <IonRow style={{ marginTop: '10px' }}>
                  <IonCol size="12">
                    <div style={{
                      backgroundColor: '#f5f5f5',
                      padding: '16px',
                      borderRadius: '12px',
                      border: '1px solid #e9ecef'
                    }}>
                      <h3 style={{
                        margin: '0 0 16px 0',
                        color: '#333',
                        fontSize: '18px',
                        fontWeight: 'bold'
                      }}>
                        Pagar na entrega
                      </h3>

                      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                        {dadosEmpresa.formaPagamento?.map((item: any, index: any) => {
                          if (!item.exibirDelivery || item.tipo === "Pix Automatizado") return null;

                          const isSelected = arrayFormaPagamento.length > 0 &&
                            arrayFormaPagamento[0].pagamento === item.nome &&
                            arrayFormaPagamento[0].tipo === item.tipo;

                          return (
                            <div
                              key={index}
                              onClick={() => handleAdicionarFormaPagamento(item.nome, item.tipo)}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                padding: '10px',
                                backgroundColor: 'white',
                                borderRadius: '8px',
                                border: isSelected ? "2px solid #FF0000" : "1px solid #e0e0e0",
                                cursor: 'pointer',
                                // transition: 'all 0.3s ease'
                              }}
                            >
                              <div style={{
                                fontWeight: 'bold',
                                fontSize: '16px',
                                color: '#333'
                              }}>
                                {item.nome}
                              </div>
                              {/* <div style={{
                                width: '20px',
                                height: '20px',
                                borderRadius: '50%',
                                border: isSelected ? '6px solid var(--ion-color-primary)' : '2px solid #dee2e6',
                                backgroundColor: isSelected ? 'var(--ion-color-primary)' : 'transparent'
                              }} /> */}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </IonCol>
                </IonRow>
              </>
            )}


        </IonGrid>

        <IonModal
          className="mini-modal"
          isOpen={showModalConfirmarCelular}
          onDidDismiss={() => { setShowModalConfirmarCelular(false); }}
          style={{
            '--backdrop-opacity': '0.4',              // opacidade do cinza
            '--backdrop-background': 'rgba(0,0,0,0.4)' // cor exata do overlay
          }}
        >
          <ConfirmarCelular nome={localStorage.getItem("nome") || ""} celular={localStorage.getItem("telefone") || ""} logado={props.logado} closeActionSimple={closeModalConfirmarCelularSimple} closeAction={closeModalConfirmarCelular}></ConfirmarCelular>
        </IonModal>


        <IonToast
          isOpen={showToast}
          position="middle"
          onDidDismiss={() => setShowToast(false)}
          message={textToast}
          duration={3000}
        />

        <IonLoading
          cssClass='my-custom-class'
          isOpen={showLoading}
          onDidDismiss={() => { setShowLoading(false); }}
          spinner='circles'
        />
      </IonContent>
      <IonFooter>

        <IonToolbar>


          <IonGrid>

            <IonRow>
              <IonCol size="12" style={{
                margin: "0px",
                padding: "0px"

              }}>
                <IonGrid style={{
                  margin: "0px",
                  padding: "0px"

                }}>
                  {arrayFormaPagamento.map((campo: any, index: any) => (
                    <div key={index} style={{ marginBottom: "6px" }} hidden={campo.tipo !== "Dinheiro"}>
                      <IonRow className="ion-align-items-center">

                        {/* Coluna do Label */}
                        <IonCol size="8" sizeMd="10" style={{
                          display: "flex", alignItems: "center",
                          marginTop: "0px",
                          paddingTop: "0px",
                          marginBottom: "0px",
                          paddingBottom: "0px"
                        }}>
                          <IonLabel style={{ fontSize: "14px", fontWeight: "bold" }}>
                            {campo.pagamento}:
                          </IonLabel>
                        </IonCol>

                        {/* Coluna do Input */}
                        <IonCol size="4" sizeMd="2" style={{
                          marginTop: "0px",
                          paddingTop: "0px",
                          marginBottom: "0px",
                          paddingBottom: "0px"
                        }}>
                          <IonInput disabled={campo.pagou}
                            clearInput={true}
                            style={{
                              "--background": "#f5f5f5",
                              height: "35px",
                              borderRadius: "20px",
                              border: "1px solid #ccc",
                              boxSizing: "border-box",
                              fontSize: "14px",
                            }}
                            type="tel"
                            maxlength={14}
                            placeholder="Valor"
                            value={campo.valor || ''}
                            onIonChange={(e: any) => onChangeValorArray(e, index)}
                          />
                        </IonCol>


                        {/* Coluna do Ícone de Exclusão */}
                        {/* <IonCol
                          size="1"
                          sizeMd="1"
                          style={{
                            textAlign: "right",
                            marginTop: "0px",
                            paddingTop: "0px",
                            marginBottom: "0px",
                            paddingBottom: "0px",
                          }}
                        >
                          <IonIcon
                            icon={trashOutline}
                            style={{
                              cursor: campo.pagou ? "not-allowed" : "pointer", // Cursor muda dependendo do estado
                              color: campo.pagou ? "gray" : "red",            // Cor muda dependendo do estado
                              fontSize: "20px",
                            }}
                            onClick={() => {
                              if (!campo.pagou) handleRemoverFormaPagamento(index); // Apenas chama se não estiver desabilitado
                            }}
                          />
                        </IonCol> */}


                      </IonRow>

                      <IonRow style={{ "borderBottom": "1px solid #e0e0e0" }}>
                        <IonCol size="6">
                          <IonLabel>Troco:</IonLabel>
                        </IonCol>
                        <IonCol size="6" style={{ textAlign: 'right' }}>

                          <IonLabel>R$ {calcularValorTroco(valorTotal, arrayFormaPagamento)}

                          </IonLabel>
                        </IonCol>
                      </IonRow>
                    </div>
                  ))}



                </IonGrid>

              </IonCol>
            </IonRow>

            {/* <IonRow>
              <IonCol size="6">
                <IonLabel>Restante:</IonLabel>
              </IonCol>
              <IonCol size="6" style={{ textAlign: 'right' }}>
                <IonLabel>R$ {calcularValorRestante(valorTotal, arrayFormaPagamento).toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })}</IonLabel>
              </IonCol>
            </IonRow>*/}











            <IonRow>
              <IonCol size="6" style={{ fontWeight: 'bold' }}>
                <IonLabel>Subtotal:</IonLabel>
              </IonCol>
              <IonCol size="6" style={{ textAlign: 'right', fontWeight: 'bold' }}>
                <IonLabel>R$ {valorTotalProdutos || "0,00"}</IonLabel>
              </IonCol>
            </IonRow>

            <IonRow hidden={!desconto}>
              <IonCol size="6" style={{}}>
                <IonLabel>Desconto:</IonLabel>
              </IonCol>
              <IonCol size="6" style={{ textAlign: 'right' }}>
                <IonLabel>- R$ {desconto || "0,00"}</IonLabel>
              </IonCol>
            </IonRow>

            <IonRow style={{ "borderBottom": "1px solid #e0e0e0" }}>
              <IonCol size="6" style={{}}>
                <IonLabel>Taxa de entrega:</IonLabel>
              </IonCol>
              <IonCol size="6" style={{ textAlign: 'right' }}>
                <IonLabel>R$ {taxaEntrega || "0,00"}</IonLabel>
              </IonCol>
            </IonRow>

            <IonRow>
              <IonCol size="6" style={{ fontWeight: 'bold', fontSize: "20px" }}>
                <IonLabel>Valor Total:</IonLabel>
              </IonCol>
              <IonCol size="6" style={{ textAlign: 'right', fontWeight: 'bold', fontSize: "20px" }}>
                <IonLabel>R$ {valorTotal || "0,00"}</IonLabel>
              </IonCol>
            </IonRow>

            <IonRow>

              <IonCol>
                <IonButton style={{ height: "46px", fontSize: "18px" }} expand="block"
                  type="submit"
                  onClick={async () => {

                    const endereco = localStorage.getItem("enderecoEntrega") || "";
                    if (endereco != "RETIRADA") {
                      // Converte as taxas para float corretamente
                      const taxaEntregaFloat = parseFloat(taxaEntrega.toString().replace(",", "."));

                      const configuracaoEncontrada =
                        Array.isArray(dadosEmpresa.configuracoesEntrega) &&
                        dadosEmpresa.configuracoesEntrega.find((config: any) => {
                          const taxaConfigFloat = parseFloat(config.taxa.replace(",", "."));
                          return taxaConfigFloat === taxaEntregaFloat;
                        });

                      // Retorna false caso não encontre nenhuma configuração correspondente
                      if (!configuracaoEncontrada) {
                        setTextToast("Selecione um endereço válido.");
                        setShowToast(true);
                        return false;
                      }
                    }


                    let valorRestante = calcularValorRestante(valorTotal, arrayFormaPagamento);

                    if (valorRestante <= 0) {

                      const tipoAgendamento = localStorage.getItem("tipoAgendamento") || "";
                      const dataAgendamento = localStorage.getItem("dataAgendamento") || "";
                      const horaAgendamento = localStorage.getItem("horaAgendamento") || "";

                      let dataReferencia = new Date();

                      if (tipoAgendamento === "AGENDADO" && dataAgendamento && horaAgendamento) {
                        // Se for agendado, usa a data e hora do agendamento
                        const dataObj = new Date(dataAgendamento);
                        const ano = dataObj.getFullYear();
                        const mes = dataObj.getMonth();
                        const dia = dataObj.getDate();

                        let hora = 0;
                        let minuto = 0;

                        if (horaAgendamento.includes('T')) {
                          // Extrair HH:mm diretamente da string ISO para evitar conversão de fuso horário
                          // O IonDatetime retorna algo como "2025-12-03T22:30:00" (às vezes com Z, às vezes sem)
                          // Queremos apenas os números visuais
                          const timePart = horaAgendamento.split('T')[1];
                          const [h, m] = timePart.split(':');
                          hora = parseInt(h);
                          minuto = parseInt(m);
                        } else {
                          const [h, m] = horaAgendamento.split(':').map(Number);
                          hora = h;
                          minuto = m;
                        }

                        dataReferencia = new Date(ano, mes, dia, hora, minuto);

                        // Validar se a data/hora não é no passado
                        const agora = new Date();
                        agora.setSeconds(0);
                        agora.setMilliseconds(0);

                        console.log("Data String:", dataAgendamento);
                        console.log("Data Local Interpretada:", dataReferencia);
                        console.log("Agora:", agora);

                        if (dataReferencia < agora) {
                          setTextToast("A data de agendamento deve ser futura.");
                          setShowToast(true);
                          return;
                        }
                      }

                      const diaAtual = dataReferencia.getDay(); // 0 a 6
                      const horarioAtual = dataReferencia.getHours() * 60 + dataReferencia.getMinutes(); // em minutos

                      const diasSemanaNumber: any = {
                        SUNDAY: 0,
                        MONDAY: 1,
                        TUESDAY: 2,
                        WEDNESDAY: 3,
                        THURSDAY: 4,
                        FRIDAY: 5,
                        SATURDAY: 6,
                      };

                      const diaAtualTexto = Object.keys(diasSemanaNumber).find(
                        (key) => diasSemanaNumber[key] === diaAtual
                      );
                      const diaAmanha = (diaAtual + 1) % 7;
                      const amanhaTexto = Object.keys(diasSemanaNumber).find(
                        (key) => diasSemanaNumber[key] === diaAmanha
                      );

                      if (dadosEmpresa.horarios) {
                        const horariosHoje = dadosEmpresa.horarios.filter(
                          (horario: any) => horario.dayOfWeek === diaAtualTexto
                        ) || [];

                        const horariosAmanha = dadosEmpresa.horarios.filter(
                          (horario: any) => horario.dayOfWeek === amanhaTexto
                        ) || [];

                        let estaDentroDoHorario = false;
                        let proximoHorarioHoje: any = null;

                        for (const horario of horariosHoje.sort((a: any, b: any) => a.start.localeCompare(b.start))) {
                          const [horaInicio, minutoInicio] = horario.start.split(":").map(Number);
                          const inicio = horaInicio * 60 + minutoInicio;
                          const fim = inicio + horario.duration;

                          if (horarioAtual >= inicio && horarioAtual <= fim) {
                            estaDentroDoHorario = true;
                            break;
                          }

                          if (horarioAtual < inicio && !proximoHorarioHoje) {
                            proximoHorarioHoje = horario;
                          }
                        }

                        const valorTotalProdutosNumerico = parseFloat(
                          valorTotalProdutos?.replace(/\./g, "").replace(/\,/g, ".")
                        );
                        const pedidoMinimoNumerico = parseFloat(
                          dadosEmpresa.pedidoMinimo?.replace(/\./g, "").replace(/\,/g, ".")
                        );

                        if (listaItemProdutos?.length === 0) {
                          setTextToast("Selecione pelo menos um produto.");
                          setShowToast(true);
                        } else if (valorTotalProdutosNumerico < pedidoMinimoNumerico) {
                          setTextToast(
                            "Pedido mínimo de R$ " + (dadosEmpresa.pedidoMinimo || "0,00") + " em produtos."
                          );
                          setShowToast(true);
                        } else if (!estaDentroDoHorario) {
                          if (proximoHorarioHoje) {
                            setTextToast(
                              `Não é possível realizar o pedido agora. Abrimos hoje às ${formatarHorario(
                                proximoHorarioHoje.start
                              )}.`
                            );
                          } else if (horariosAmanha.length > 0) {
                            const proximoHorarioAmanha = horariosAmanha.sort((a: any, b: any) =>
                              a.start.localeCompare(b.start)
                            )[0];
                            setTextToast(
                              `Estamos fechados. Abrimos amanhã às ${formatarHorario(
                                proximoHorarioAmanha.start
                              )}.`
                            );
                          } else {
                            setTextToast("Não é possível realizar o pedido, está fora do horário de funcionamento.111");
                          }
                          setShowToast(true);
                        } else {
                          console.log("desconto", desconto);
                          if (
                            !desconto || (desconto &&
                              Array.isArray(dadosEmpresa.configuracoesCupom) &&
                              dadosEmpresa.configuracoesCupom.some((cupom: any) => cupom.valor === desconto))
                          ) {

                            setShowModalConfirmarCelular(true);

                          }
                          else {
                            window.localStorage.removeItem("desconto");
                            setDesconto("");

                            setTextToast("Desconto inválido.");
                            setShowToast(true);
                          }
                        }
                      } else {
                        setTextToast("Não é possível realizar o pedido, está fora do horário de funcionamento.222");
                        setShowToast(true);
                      }

                    } else {
                      setTextToast("Ainda falta R$ " + valorRestante.toLocaleString('pt-BR', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      }) + " para fechar. Selecione a forma de pagamento.");
                      setTextToast("Selecione a forma de pagamento.");
                      setShowToast(true);
                    }

                  }}
                >
                  Continuar
                </IonButton>
              </IonCol>
            </IonRow>
          </IonGrid>




        </IonToolbar>
      </IonFooter >

      <IonModal
        className="medium-modal"
        isOpen={showRevisarPedido}
        onDidDismiss={() => { setShowRevisarPedido(false); }}
        style={{
          '--backdrop-opacity': '0.4',              // opacidade do cinza
          '--backdrop-background': 'rgba(0,0,0,0.4)' // cor exata do overlay
        }}
      >
        <RevisarPedido
          valorTotal={valorTotal}
          enderecoEntrega={localStorage.getItem("enderecoEntrega") || ""}
          complementoEntrega={localStorage.getItem("complementoEntrega") || ""}
          formaPagamento={arrayFormaPagamento[0]?.tipo || ""}
          tempoEntrega={localStorage.getItem("tempoEntrega") || ""}
          taxaEntrega={localStorage.getItem("taxaEntrega") || "0,00"}
          isRetirada={(localStorage.getItem("enderecoEntrega") || "") === "RETIRADA"}
          desconto={(localStorage.getItem("desconto") || "")}
          empresaEndereco={dadosEmpresa.empresaEndereco || ""}
          tipoAgendamento={localStorage.getItem("tipoAgendamento") || ""}
          dataAgendamento={localStorage.getItem("dataAgendamento") || ""}
          horaAgendamento={localStorage.getItem("horaAgendamento") || ""}
          closeAction={() => {
            setShowRevisarPedido(false);

            const nomeLocal = (localStorage.getItem("nome") || "").trim();
            const telefoneLocal = (localStorage.getItem("telefone") || "").trim();
            const telefoneDigits = telefoneLocal.replace(/\D/g, "");
            const telefoneValido = telefoneDigits.startsWith("55") && (telefoneDigits.length === 13);

            if (!nomeLocal || !telefoneValido) {
              setTextToast("Informe nome e celular válidos.");
              setShowToast(true);
              setShowModalConfirmarCelular(true);
              return;
            }

            // Verifica se a forma de pagamento é Mercado Pago
            const tipoFormaPagamentoSelecionada = arrayFormaPagamento[0]?.tipo;

            console.log("tipoFormaPagamentoSelecionada", tipoFormaPagamentoSelecionada);

            if (tipoFormaPagamentoSelecionada == "Pix Automatizado") {
              // Para Mercado Pago, gera QR Code
              gerarPagamentoMercadoPago();
            } else {
              // Para outras formas de pagamento, faz o pedido direto
              fazerPedido();
            }
          }}
          closeActionSimple={() => setShowRevisarPedido(false)}
        /> </IonModal>


      <IonModal className="fullscreen-modal" isOpen={showModalQrCode} onDidDismiss={() => {
        setShowModalQrCode(false);
        pararVerificacaoPagamento(); // Para a verificação quando o modal for fechado
      }}>
        <IonHeader className="ion-no-border">
          <IonToolbar>
            <IonButtons slot="start">
              <IonIcon slot="icon-only" icon={arrowBack} onClick={() => {
                setShowModalQrCode(false);
                pararVerificacaoPagamento(); // Para a verificação quando clicar em voltar
              }} />
            </IonButtons>
            <IonTitle>Detalhes do pagamento</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent>




          <IonCard className="div-qrcode-pagamento">
            <IonCardContent>

              {/* Título Assinatura */}
              <IonLabel className="qr-code-pagamento">
                <h2><b>{localStorage.getItem("empresanome") || "Pedido"}</b></h2>
              </IonLabel>

              {/* Valor do pagamento */}
              <IonLabel>
                <p className="payment-title">Pague <b>R$ {valorTotal?.toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })}</b> via <b>Pix</b></p>
              </IonLabel>

              <IonLabel className="qr-code-pagamento-margin">
                <h3>Para pagar, escolha uma destas opções:</h3>
              </IonLabel>

              {/* Código QR */}
              <IonCardContent className="qr-code-pagamento">
                <IonLabel>
                  <p>Código QR</p>
                </IonLabel>
                {qrCodeData && <img src={`data:image/png;base64,${qrCodeData}`} alt="QR Code" />}
              </IonCardContent>

              {/* Código de pagamento e botão de cópia */}
              <IonCardContent className="qr-code-pagamento">
                <IonLabel>
                  <p>Código de pagamento</p>
                </IonLabel>
                <div className="copy-code-container">
                  {/* Substituído por IonTextarea */}
                  <IonTextarea
                    readonly={true}
                    style={{ "--background": "#eeeeee" }}
                    rows={2}
                    value={qrCode}
                  />
                  <IonButton fill="clear" onClick={() => {
                    navigator.clipboard.writeText(qrCode);
                    setTextToast("Código copiado");
                    setShowToast(true);
                  }}>
                    <IonIcon color="primary" icon={copy} />
                  </IonButton>
                </div>

              </IonCardContent>

              <IonLabel className="qr-code-pagamento">
                Código válido por: <h1>{minutes}:{seconds < 10 ? `0${seconds}` : seconds}</h1>
              </IonLabel>
              {/* Instruções de como pagar */}
              <IonCardContent>

                <IonLabel>
                  <p><b>Como pagar?</b></p>
                  <ol>
                    <li>Entre no app ou site do seu banco e escolha a opção de pagamento via Pix.</li>
                    <li>Escaneie o código QR ou copie e cole o código de pagamento.</li>
                    <li>Pronto! Agora é só aguardar o pagamento ser processado.</li>
                  </ol>
                </IonLabel>
              </IonCardContent>


            </IonCardContent>
          </IonCard>








        </IonContent>

      </IonModal>

    </>


  );
};

export default ({ produtos, logado, closeAction, closeActionSimple }: { produtos: any[], logado: any, closeAction: Function, closeActionSimple: Function }) => (
  <OrdensFechar produtos={produtos} logado={logado} closeAction={closeAction} closeActionSimple={closeActionSimple}>
  </OrdensFechar>
)
